var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tags",attrs:{"id":"tags-home"}},_vm._l((10),function(tag,index){return _c('div',{key:index,staticClass:"tag",attrs:{"data-aos":"zoom-in"}},[_vm._v("\n                  Tech Content\n                ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0460372a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Blogs/BlogCategories.vue
// module id = 1344
// module chunks = 1